import React, { useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Videosection() {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: "40px",
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          centerPadding: "40px",
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerPadding: "30px",
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: "25px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "15px",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "10px",
        },
      },
    ],
  };

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickPlay();
    }
  }, []);

  return (
    <section
      className="videosection"
      style={{
        padding: "40px 0",
      }}
    >
      <div className="container">
        <Slider ref={sliderRef} {...settings}>
          {[
            "https://www.youtube.com/embed/Ip1CQnBd9HY?rel=0&enablejsapi=1",
            "https://www.youtube.com/embed/JDcU9J5aTV8?rel=0&enablejsapi=1",
            "https://www.youtube.com/embed/dtTm4xup6aA?rel=0&enablejsapi=1",
            "https://www.youtube.com/embed/Zu4GrIPkh6g?rel=0&enablejsapi=1",
            "https://www.youtube.com/embed/WDZK1C_nHC6hXg27",
          ].map((url, i) => (
            <div key={i} className="video-slide">
              <div
                style={{
                  position: "relative",
                  paddingBottom: "177.7778%",
                  height: 0,
                  overflow: "hidden",
                  borderRadius: "20px",
                }}
              >
                <iframe
                  src={url}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    border: 0,
                    borderRadius: "20px",
                  }}
                  allowFullScreen
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
